import './bootstrap';

import Alpine from 'alpinejs';
import Clipboard from "@ryangjchandler/alpine-clipboard"
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { datadogRum } from '@datadog/browser-rum';

if (import.meta.env.VITE_APP_ENV !== 'local') {
    datadogRum.init({
        applicationId: import.meta.env.VITE_DATADOG_APP_ID,
        clientToken: import.meta.env.VITE_DATADOG_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'ap2.datadoghq.com',
        service: 'nexus',
        env: import.meta.env.VITE_APP_ENV,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
    });
}

window.Alpine = Alpine;
window.Chart = Chart;
window.ChartDataLabels = ChartDataLabels;

Alpine.plugin(Clipboard)
Alpine.start();

import.meta.glob([
  '../images/**',
  '../fonts/**',
  '../vendor/**/*.js',  // Handle any vendor JS files
  '../js/**',           // Handle any additional JS files in resources/js'
  '../css/**',
  '../pdf/**'
]);
